module.exports = __webpack_public_path__ + "static/media/piano-keyboard.5c47a102.svg";